/**
 * Where old Diagnostics bookmarks land.
 *
 * Cloud and the General hash used to be the page. They stay as redirects so a
 * deleted route is not a 404.
 */

export const DIAGNOSTICS_SETTINGS_PATH = "/settings/diagnostics" as const;

export function settingsCloudRedirect() {
  return {
    to: DIAGNOSTICS_SETTINGS_PATH,
    replace: true as const,
  };
}

export function settingsGeneralHashRedirect(hash: string): {
  readonly to: typeof DIAGNOSTICS_SETTINGS_PATH;
  readonly replace: true;
} | null {
  const id = hash.startsWith("#") ? hash.slice(1) : hash;
  if (id !== "diagnostics") return null;
  return {
    to: DIAGNOSTICS_SETTINGS_PATH,
    replace: true,
  };
}
